// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CloudSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M7.11 3.991A1.5 1.5 0 1 0 4.89 6.01L8.974 10.5A8.5 8.5 0 0 0 9 27.5h11a11.408 11.408 0 0 0 3.832-.655l1.058 1.164a1.5 1.5 0 0 0 2.22-2.018l-20-22ZM20 24.5H9a5.5 5.5 0 0 1-.225-10.994A11.488 11.488 0 0 0 8.5 16a1.5 1.5 0 0 0 3 0c0-.797.112-1.59.332-2.355l9.735 10.709A8.586 8.586 0 0 1 20 24.5ZM31.5 16a11.415 11.415 0 0 1-2.191 6.75 1.5 1.5 0 1 1-2.427-1.764A8.5 8.5 0 0 0 15.687 8.67a1.5 1.5 0 0 1-1.525-2.582A11.5 11.5 0 0 1 31.5 16Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
